import type { BannerCarrosselProps } from "../../banner-carrossel.props"
import { ContentBanner } from "../conteudoBanner/ContentBanner"
import { BannerCarrosselMidia } from "../conteudoBanner/BannerCarrosselMidia"
import { priceFormatter } from "@/utils/formatter"
import { CountDown } from "../conteudoBanner/countDown/CountDown"

interface BannerCarrosselPadraoProps {
    banner: BannerCarrosselProps
    fullBannerDinamico: boolean
    alturaBannerDinamico: number
    exibeNomeBannerDinamico: boolean
    exibeValoresSomenteLogado: boolean
    width: number
    height: number
    idx: number
    isFirst: boolean
    device: number
}

export function BannerCarrosselPadrao({
    banner,
    fullBannerDinamico,
    alturaBannerDinamico,
    exibeNomeBannerDinamico,
    exibeValoresSomenteLogado,
    width,
    height,
    idx,
    isFirst,
    device
}: Readonly<BannerCarrosselPadraoProps>) {

    return (
        <ContentBanner banner={banner}>
            {!fullBannerDinamico || (fullBannerDinamico && alturaBannerDinamico == 0 || !alturaBannerDinamico) ? (
                <>
                    <BannerCarrosselMidia
                        banner={banner}
                        width={width}
                        height={height}
                        idx={idx}
                        isFirst={isFirst}
                    />

                    {exibeNomeBannerDinamico && (
                        <p className="banner-name flex justify-center center" dangerouslySetInnerHTML={{ __html: banner.legenda || banner.titulo }} />
                    )}
                </>
            ) : (fullBannerDinamico && !exibeValoresSomenteLogado && banner.valida_estoque && banner.valor) && (() => {
                    const rawOpcoes = banner.opcoes
                    const opcoes = typeof rawOpcoes === "string" ? JSON.parse(rawOpcoes) : rawOpcoes ?? {}
                    const precoBannerClassName = `preco-banner${opcoes.posicao ? ' ' + opcoes.posicao : ''}`

                    return (
                        <div className="container container-banner">
                            <div className={precoBannerClassName}>
                                <div
                                    className="valor-total"
                                    style={opcoes.corPreco ? { color: `#${opcoes.corPreco}` } : {}}
                                >
                                    {priceFormatter.format(banner.valor_boleto)}
                                </div>
                            </div>
                        </div>
                    )
                })()
            }

            {(banner.timer && banner.data_inicio && banner.data_fim) && (
                <CountDown banner={banner} device={device} refresh={true} />
            )}
        </ContentBanner>
    )
}